module.exports = __webpack_public_path__ + "img/classiccar-2.88f99b2c.jpg";